import { ApiUrl2,UserToken } from '../../../helper/HelperAuth'
import doFetch from '../../../infra/helper/fetchHelper'
import {fromJS} from "immutable";

export default (group_id) => async (dispatch, getState) => {
    const Authorization = UserToken;
    const url = ApiUrl2 + 'config-templategroup-view';
    var paramBody = {
        "data":{
            "group-id":group_id
        }
    }

    const argument = {
        method: 'POST',
        headers : {
            'Content-Type':'application/json',
            'Authorization': Authorization,
        },
        body : JSON.stringify(paramBody)
    };

    const response = await doFetch(url,argument);
    var data = fromJS({});
    data = fromJS(await response.json());
    data = data.get('query-result');
    return data;
};